module.exports = __webpack_public_path__ + "static/media/007_eventcentric_redesign.0e7873e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp_org/007_eventcentric_redesign.png
// module id = 543
// module chunks = 0